module.exports = __webpack_public_path__ + "static/media/settings.fc6d2431.png";